module.exports = __webpack_public_path__ + "img/mobile-mask.db629c63.png";